import styles from 'components/Player/AudioPlayerWrapper/PlayQueue/PlayQueue.module.scss';
import { useTranslation } from 'hooks/useTranslation';
import { PlayQueueCard } from 'components/Player/AudioPlayerWrapper/PlayQueue/PlayQueueCard';
import { usePlayerState } from 'contexts/PlayerStateContext';

const CurrentlyPlaying = () => {
  const t = useTranslation();
  const { currentlyPlayingId } = usePlayerState();

  if (!currentlyPlayingId) return null;

  return (
    <div className={styles.container}>
      <h3 className={styles.subTitle}>{t('nowPlaying')}</h3>
      <div className={styles.cardContainer}>
        <PlayQueueCard
          isActive={true}
          isCheckboxSelected={false}
          item={{
            key: 'playlist-currently-playing',
            programId: currentlyPlayingId,
          }}
          setCheckboxSelected={() => {}}
        />
      </div>
    </div>
  );
};

export default CurrentlyPlaying;
